module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.CapsuleLogoResized-547a36d36eaa4ce20cfc3ec96e80b581.png";